<app-admin-applications-list></app-admin-applications-list>
